import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const zoneList = createAsyncThunk('zone/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `zone`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const zoneDetails = createAsyncThunk('zone/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `zone/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addZone = createAsyncThunk('zone/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'zone',
            data: {
                "premise_id": data?.values?.premise,
                "zone_name": data?.values?.name
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateZone = createAsyncThunk('zone/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'zone',
            data: {
                "zone_id": data?.values?.id,
                "premise_id": data?.values?.premise,
                "zone_name": data?.values?.name
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delZone = createAsyncThunk('zone/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `zone/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const zone = createSlice({
    name: 'zone',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(zoneList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(zoneList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(zoneList.rejected, (state, action) => {
            state.loading = false;
        })

        builder.addCase(zoneDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default zone.reducer;